import React from 'react';

const ConferenceOverview = ({ language }) => (
  <section className="pb-5 bg-light" data-aos="fade-up">
    <div className="container">
        <h1 className="display-4 fw-bold text-black text-center">
          {language === 'en' ? 'Conference Hall' : 'የኮንፈረንስ አዳራሽ'}
        </h1>
        <p className="lead mt-2 text-center">
          {language === 'en' 
            ? 'Fully equipped meeting room for business meetings and small events. Capacity up to 80 people.' 
            : 'ለንግድ ስብሰባዎች እና ትናንሽ ዝግጅቶች የተሟላ የስብሰባ ክፍል። እስከ 80 ሰዎች የሚያስተናግድ።'
          }
        </p>
  <h2 className="fw-bold mb-4">
  {language === 'en' ? 'Overview' : 'አጠቃላይ እይታ'}
</h2>
<p>
  {language === 'en'
    ? 'Our meeting room is perfect for business meetings, workshops, and small corporate events. The room is equipped with modern sound systems, wireless microphones, LCD projector, and air conditioning to ensure a comfortable and productive environment.'
    : 'የስብሰባ ክፍላችን ለንግድ ስብሰባዎች፣ ለስልጠናዎች እና ለትናንሽ የድርጅት ዝግጅቶች ተስማሚ ነው። ክፍሉ ዘመናዊ የድምፅ ሲስተም፣ ሽቦ አልባ ማይክሮፎን፣ ኤልሲዲ ፕሮጀክተር እና አየር ማቀዝቀዣ የተገጠመለት ምቹ እና ውጤታማ አካባቢ ይሰጣል።'
  }
</p>
      <ul className="list-group mt-3">
  <li className="list-group-item">
    {language === 'en'
      ? 'Meeting room capacity: Up to 80 people'
      : 'የስብሰባ ክፍል አቅም፡ እስከ 80 ሰዎች'
    }
  </li>
  <li className="list-group-item">
    {language === 'en'
      ? 'Modern sound system & wireless microphones'
      : 'ዘመናዊ የድምፅ ስርዓት እና ሽቦ አልባ ማይክሮፎኖች'
    }
  </li>
  <li className="list-group-item">
    {language === 'en'
      ? 'LCD projector for presentations'
      : 'ለዝግጅት ለአቀራረቦች LCD ፕሮጀክተር'
    }
  </li>
  <li className="list-group-item">
    {language === 'en'
      ? 'Ideal for weddings, birthdays, corporate events'
      : 'ለጋብቻ፣ ለየልደት እና ለድርጅታዊ ዝግጅቶች ተስማሚ'
    }
  </li>
   <li className="list-group-item">
    {language === 'en'
      ? 'VIP Meeting Hall up to 60 pepople'
      : 'ቪአይፒ ስብሰባ አዳራሽ ለ 60 ሰዎቸ ይሚበቃ'
    }
  </li>
</ul>


    </div>
  </section>

  
);

export default ConferenceOverview;
